var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 6.5H7.00002M17 6.5H18.3087C20.3944 6.5 21.4373 6.5 22.0335 7.16616C22.6298 7.83231 22.5146 8.86879 22.2843 10.9417L21.9884 13.6043C21.5183 17.8356 21.2832 19.9513 19.8594 21.2256C18.4356 22.5 16.2904 22.5 12 22.5C7.70962 22.5 5.56443 22.5 4.14063 21.2256C2.71683 19.9513 2.48176 17.8356 2.01161 13.6043L1.71577 10.9417C1.48544 8.86879 1.37028 7.83231 1.96652 7.16616C2.56276 6.5 3.60561 6.5 5.6913 6.5H7.00002M17 6.5C17 3.73858 14.7614 1.5 12 1.5C9.30679 1.5 7.1109 3.62938 7.00409 6.29641C7.00139 6.36394 7.00002 6.43181 7.00002 6.5",
    stroke: "#00205E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotimage);
export default __webpack_public_path__ + "static/media/lotimage.59cc1aaa1aad0d158235c875c856b709.svg";
export { ForwardRef as ReactComponent };